<template>
  <v-dialog v-model="show" max-width="600" persistent>
    <v-card>
      <v-card-title class="headline primary white--text">
        <v-icon left color="white">mdi-cart-check</v-icon>
        Confirmação de Compra
      </v-card-title>

      <v-card-text class="pt-4">
        <v-row>
          <v-col cols="12" sm="6">
            <div class="summary-item">
              <span class="label">Placa do Veículo</span>
              <span class="value">{{ summaryData.plate }}</span>
              <span v-if="summaryData.vehicleDescription" class="sub-value">{{ summaryData.vehicleDescription }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="6">
            <div class="summary-item">
              <span class="label">Categoria</span>
              <span class="value">{{ summaryData.category }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="6">
            <div class="summary-item">
              <span class="label">Tempo / Produto</span>
              <span class="value">{{ summaryData.productName }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="6">
            <div class="summary-item">
              <span class="label">Valor Total</span>
              <span class="value price">R$ {{ formatMoney(summaryData.price) }}</span>
            </div>
          </v-col>

          <v-col cols="12">
            <v-divider class="my-2"></v-divider>
          </v-col>

          <v-col cols="12" sm="6">
            <div class="summary-item">
              <span class="label">CPF/CNPJ</span>
              <span class="value">{{ summaryData.document }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="6">
            <div class="summary-item">
              <span class="label">Celular</span>
              <span class="value">{{ summaryData.phone }}</span>
            </div>
          </v-col>

          <v-col cols="12">
            <div class="summary-item">
              <span class="label">E-mail</span>
              <span class="value">{{ summaryData.email }}</span>
            </div>
          </v-col>
        </v-row>

        <v-alert type="info" text dense class="mt-4 mb-0">
          <div class="d-flex align-center">
            <v-icon left color="info">mdi-information</v-icon>
            <span>Verifique se os dados estão corretos antes de finalizar.</span>
          </div>
        </v-alert>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-btn text color="grey darken-1" @click="close" :disabled="loading">
          Voltar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            color="success"
            large
            @click="confirm"
            :loading="loading"
        >
          <v-icon left>mdi-check</v-icon>
          Finalizar Compra
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PublicActivationSummary",
  props: {
    value: {
      type: Boolean,
      required: true
    },
    summaryData: {
      type: Object,
      required: true,
      default: () => ({
        plate: '',
        vehicleDescription: '',
        category: '',
        productName: '',
        price: 0,
        document: '',
        phone: '',
        email: ''
      })
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    confirm() {
      this.$emit('confirm');
    },
  }
}
</script>

<style scoped>
.summary-item {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.value {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.sub-value {
  font-size: 13px;
  color: #888;
}

.price {
  color: #2196F3;
  font-weight: 700;
  font-size: 18px;
}
</style>
